import AppState from "../AppState";

export const selectAdapterInfo = (state: AppState) => {
  return state.adapterConfig && state.adapterConfig.AdapterInfo;
};

export const selectIsAnalyticsEnabled = (state: AppState) => {
  return (
    true
  );
};

export const selectIsCategoryProductsV2Available = (
  state: AppState,
): boolean => {
  return (
    state.adapterConfig?.AdapterInfo?.operations?.includes(
      "GET /v2/{accountId}/categories/{categoryId}/products",
    ) || false
  );
};
